module.exports = __webpack_public_path__ + "static/media/img_Inscription_none@2x.4f3acf6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_none@2x.png
// module id = 997
// module chunks = 0